import React from 'react';
import Hero from '../components/Hero';
import ServiceGrid from '../components/ServiceGrid';
import AdComposer from '../components/AdComposer';
import ValueProposition from '../components/ValueProposition';
import Testimonials from '../components/Testimonials';
import FAQ, { faqs } from '../components/FAQ';
import SEO from '../components/SEO';

function Home() {
  return (
    <div className="home-page">
      <SEO 
        title="Book Newspaper Ads Online - Lowest Rates Guaranteed"
        description="India's #1 Platform to book newspaper ads online. Book Matrimonial, Property, Recruitment, Name Change ads in Times of India, Hindustan Times & 500+ newspapers."
        keywords="book newspaper ad, newspaper advertising agency, times of india ad booking, matrimonial ad rates, property ad booking, name change ad online"
        url="/"
        faqData={faqs}
      />
      <Hero />
      <ServiceGrid />
      <AdComposer />
      <ValueProposition />
      <Testimonials />
      <FAQ />
    </div>
  );
}

export default Home;
